import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { DropDownFilterCell } from '@/components/BsrsGrid'

import startCase from 'lodash/startCase'

const prettifyName = (value) => {
  const name = (value ? value.name : value)
  return (name ? startCase(name) : name)
}

export default function (stepNames) {
  return class StepNameCell extends GridCell {
    render () {
      const { dataItem, field } = this.props
      const stepId = dataItem[field]
      const name = prettifyName(stepNames.find(x => x.id === stepId))
      return (<td>{typeof name === 'string' ? name : stepId}</td>)
    }
  }
}

export function createStepNameFilterCell (stepNames, localize) {
  const defaultItem = { id: -1, name: localize('Common.SelectValue') }
  const data = stepNames.map(x => ({ ...x, name: prettifyName(x) }))
  return DropDownFilterCell(data, { dataItemKey: 'id', textField: 'name', defaultItem })
}

export function excelStepNameCell ({ dataItem, field, additionalProps }) {
  const stepId = dataItem[field]
  const name = prettifyName(additionalProps.stepNames.find(x => x.id === stepId))
  return (typeof name === 'string' ? name : stepId)
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/stepNameCell.js